import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import QuickBookingFooter from '../components/QuickBookingFooter';

import './styles/QuickBookingContainer.scss';

class QuickBookingContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenRadioOptionValue: props.defaultRadioValue
    };
    this.onRadioOptionChange = this.onRadioOptionChange.bind(this);
  }

  onRadioOptionChange(e) {
    this.setState({
      chosenRadioOptionValue: Number(e.currentTarget.value)
    });
  }

  render() {
    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, {
        startQuickBooking: () => this.props.startBooking(),
        pendingBooking: this.props.pendingBooking
      })
    );
    return (
      <div
        className={ `quick-booking-container ${
          this.props.greyOut ? 'quick-booking-container-grey-out' : ''
        }` }
      >
        <div
          className={ this.props.pendingBooking ? 'quick-booking-pending' : '' }
        >
          {childrenWithProps}
          {this.props.pendingBooking && (
            <div className="footer-wrapper">
              <QuickBookingFooter
                chosenRadioOptionValue={ this.state.chosenRadioOptionValue }
                radioOptions={ this.props.radioOptions }
                radioButtonsLabel={ this.props.radioButtonsLabel }
                onRadioOptionChange={ this.onRadioOptionChange }
                bookingCancelAction={ () => this.props.cancelBooking() }
                bookingNextAction={ () =>
                  this.props.confirmBooking(this.state.chosenRadioOptionValue)
                }
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

QuickBookingContainer.propTypes = {
  children: PropTypes.node,
  startBooking: PropTypes.func,
  pendingBooking: PropTypes.bool,
  greyOut: PropTypes.bool,
  cancelBooking: PropTypes.func,
  confirmBooking: PropTypes.func,
  radioOptions: PropTypes.arrayOf(PropTypes.shape({})),
  defaultRadioValue: PropTypes.number,
  radioButtonsLabel: PropTypes.string
};

QuickBookingContainer.defaultProps = {
  children: null,
  startBooking: () => {},
  pendingBooking: false,
  greyOut: false,
  cancelBooking: () => {},
  confirmBooking: () => {},
  radioOptions: [],
  defaultRadioValue: 1,
  radioButtonsLabel: ''
};

export default connect(null, null)(QuickBookingContainer);



// WEBPACK FOOTER //
// ./src/containers/QuickBookingContainer.js